export default __webpack_public_path__ + "static/media/bocongthuong.8ef398be.jpg";